<template>
  <div>
    <div
      v-if="yacht.deal_reviewed_at && yacht.deal_approved === false"
      class="radius-5 elevation-5 mb-2"
    >
      <v-card-text>
        <strong class="error--text">
          Rejected on {{ yacht.deal_reviewed_at | moment('ll') }}
        </strong><br>
        {{ yacht.deal_declined_reason }}
      </v-card-text>
    </div>

    <v-btn
      color="primary"
      class="text-capitalize"
      block
      rounded
      text
      @click="$emit('create:offer')"
    >
      <v-icon
        left
        small
      >
        file_copy
      </v-icon>
      Create Offer
    </v-btn>
    <v-tooltip
      top
      :disabled="canApplyForApproval"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="secondary"
          class="text-capitalize"
          block
          :dark="canApplyForApproval"
          rounded
          :disabled="!canApplyForApproval"
          @click="$emit('update:status', yachtStatuses.INVESTMENT_STATUS_APPROVAL)"
          v-on="on"
        >
          <v-icon
            left
            small
          >
            arrow_forward
          </v-icon>
          Apply for Approval
        </v-btn>
      </template>
      <span>
        You have to create an offer for the yacht owner first
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import Yacht from '@/models/Yacht'

export default {
    name: 'Sales',
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    },
    computed: {
      canApplyForApproval() {
        return !!this.yacht.finance_model
      }
    }
  }
</script>

<style scoped>

</style>
